import PropTypes from 'prop-types';
import React, { Component } from 'react';
import trim from 'lodash/trim';

import _ from 'utils/i18n';

const AnswerLabel = _('Answer');

class FreeText extends Component {

    static canContinue(answer, config) {
        const {answer_optional} = config;

        return !Boolean(answer && (answer_optional || (answer.text && trim(answer.text))));
    }

    render() {
        const {answer} = this.props;

        return (
            <div>
                <textarea
                    className="outline-black"
                    id="lesson-block-free-text"
                    cols="30"
                    rows="10"
                    value={answer.text || ''}
                    onChange={this.onChange}
                />
                <label htmlFor="lesson-block-free-text">{AnswerLabel}</label>
            </div>
        );
    }

    onChange = event => {
        const target = event.currentTarget;
        const text = target.value;

        return this.props.updateAnswer({text});
    };

}

FreeText.propTypes = {
    answer: PropTypes.shape({
        text: PropTypes.string,
    }).isRequired,
    updateAnswer: PropTypes.func.isRequired,
};

export default FreeText;



// WEBPACK FOOTER //
// ./scripts/frontend/lessons/components/FreeText.js